import React from 'react';
import { Card, Button, Form } from 'react-bootstrap';

const CategorySidebar = ({ allGrupos, activeCategory, onCategoryChange, searchTerm, onSearchChange, disabled = false }) => {
  return (
    <Card style={{ position: 'sticky', top: 10, border: '1px solid #dee2e6' }}>
      <Card.Body className="p-3">
        <h6 className="mb-3" style={{ fontWeight: 600, color: 'var(--text-color, #495057)' }}>Categorias</h6>
        <div className="d-flex flex-column gap-2">
          {allGrupos.map(grupo => (
            <Button
              key={grupo.id}
              size="sm"
              className="text-start d-flex justify-content-between align-items-center"
              onClick={() => onCategoryChange(grupo.id)}
              disabled={disabled}
              style={{
                fontWeight: activeCategory === grupo.id ? 600 : 400,
                borderLeft: `4px solid ${grupo.color}`,
                backgroundColor: activeCategory === grupo.id ? 'var(--brand-light-green, #8fad15)' : 'transparent',
                color: activeCategory === grupo.id ? '#fff' : 'var(--text-color, #212529)',
                border: activeCategory === grupo.id ? 'none' : '1px solid #dee2e6'
              }}
            >
              <span>{grupo.icon} {grupo.nome}</span>
              <span className="badge" style={{ backgroundColor: activeCategory === grupo.id ? 'rgba(255,255,255,0.3)' : '#6c757d' }}>{grupo.comandos.length}</span>
            </Button>
          ))}
        </div>
        <hr className="my-3" />
        <Form.Control
          type="text"
          placeholder="Filtrar comandos..."
          value={searchTerm}
          onChange={e => onSearchChange(e.target.value)}
          size="sm"
        />
      </Card.Body>
    </Card>
  );
};

export default CategorySidebar;
